// Net Worth, as a pure function of a kingdom's saved data — so the game (src/game/netWorth.js) and the server (the Registry, server/registry.js)
// compute the SAME number from the same save. Net worth = liquid Mao Coin + real estate that appreciates 15 % per real calendar year from
// when each asset was acquired (purchasedAt; starter assets fall back to the profile's joinedAt). The home is valued by its level (shack base
// vs the manor upgrade); every other owned, non-wild plot counts as a LAND parcel; buildings add their own value on top.

import { RealEstatePrices, HOME_SHACK_BASE, AssetAppreciationPerYear, HomeLevels, PlotTypes } from '../config/balance.js'

const YEAR_MS = 365.25 * 24 * 3600 * 1000

function appreciated(base, sinceMs, now) {
  const years = Math.max(0, (now - (sinceMs || 0)) / YEAR_MS)
  return base * Math.pow(1 + AssetAppreciationPerYear, years)
}

// kingdom: one kingdom's saved data ({ buildings, plots }); joinedAt: profile.joinedAt (ms).
export function computeRealEstateValue(kingdom, joinedAt = 0, now = Date.now()) {
  const joined = joinedAt || now
  let total = 0
  for (const b of kingdom?.buildings ?? []) {
    total += appreciated(RealEstatePrices[b.type] ?? RealEstatePrices.OTHER, b.purchasedAt ?? joined, now)
  }
  for (const plot of Object.values(kingdom?.plots ?? {})) {
    if (!plot || plot.type === PlotTypes.WILD) continue
    if (plot.type === PlotTypes.HOME) {
      const base = (plot.homeLevel || HomeLevels.SHACK) === HomeLevels.MIDDLE ? RealEstatePrices.HOME_MIDDLE : HOME_SHACK_BASE
      total += appreciated(base, plot.purchasedAt ?? joined, now)
    } else {
      total += appreciated(RealEstatePrices.LAND, plot.purchasedAt ?? joined, now)
    }
  }
  return Math.round(total)
}

export function computeNetWorth(kingdom, joinedAt = 0, now = Date.now()) {
  return Math.round(Number(kingdom?.wealth ?? 0) + computeRealEstateValue(kingdom, joinedAt, now))
}
